<script>
import Cropper from 'cropperjs';

export default {
    props: {
        currentImage: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            currentImageSrc: this.currentImage,
            imageDetails: {
                image_x: null,
                image_y: null,
                image_width: null,
                image_height: null,
                image_rotate: null,
                image_scaleX: null,
                image_scaleY: null,
            },
            loading: false,
            newImageSrc: '',
            showCurrentImage: true,
            showNewImage: false,
        };
    },

    methods: {
        loadSelectedImage() {
            this.loading = true;
            this.showCurrentImage = false;

            let reader = new FileReader();
            reader.onload = e => {
                this.loading = false;
                this.showNewImage = true;
                this.newImageSrc = e.target.result;
            };
            reader.readAsDataURL(event.target.files[0]);
        },

        setupImageCropping() {
            let e = this.$el.querySelector('.new-profile-image');
            let width = e.offsetWidth;
            let height = e.offsetHeight;
            let cropper = new Cropper(e, {
                aspectRatio: 1,
                minCropBoxWidth: width > 64 ? 64 : 0,
                minCropBoxHeight: height > 64 ? 64 : 0,
                crop: () => {
                    var e = cropper.getData(true);
                    this.imageDetails.image_x = e.x;
                    this.imageDetails.image_y = e.y;
                    this.imageDetails.image_width = e.width;
                    this.imageDetails.image_height = e.height;
                    this.imageDetails.image_rotate = e.rotate;
                    this.imageDetails.image_scaleX = e.scaleX;
                    this.imageDetails.image_scaleY = e.scaleY;
                },
            });
        },
    },

    mounted() {
        // When the profile image is changed due to deletion, for example, we need to set it here
        Events.$on('page.users-profile.profile-image-changed', src => {
            this.loading = false;
            this.showNewImage = false;
            this.showCurrentImage = true;
            this.currentImageSrc = src;
        });
    },
};
</script>
